import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Mail, X, Send, Inbox } from 'lucide-react'
import { api } from '../services/api'
import toast from 'react-hot-toast'

// 仅网页版显示,桌面 EXE 不渲染
const DESKTOP = import.meta.env.VITE_DESKTOP === '1'

export default function MailboxButton() {
  const [open, setOpen] = useState(false)
  const [content, setContent] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const trimmed = content.trim()
    if (!trimmed) {
      toast.error('请先写下你的意见或建议')
      return
    }

    setIsSubmitting(true)
    try {
      const res = await api.post('/api/v1/feedback', { content: trimmed })
      if (res.data?.success) {
        toast.success(res.data?.message || '已收到你的意见，感谢反馈！')
        setContent('')
        setOpen(false)
      } else {
        toast.error(res.data?.message || '提交失败，请稍后再试')
      }
    } catch (error: any) {
      toast.error(error.response?.data?.message || error.message || '提交失败，请稍后再试')
    } finally {
      setIsSubmitting(false)
    }
  }

  if (DESKTOP) return null

  return (
    <>
      {/* 悬浮按钮:右下角常驻 */}
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        aria-label="意见信箱"
        className="fixed bottom-6 right-6 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#8b2e1f] text-white shadow-lg shadow-[rgba(139,46,31,0.35)] transition-transform hover:scale-105 active:scale-95"
      >
        <Mail className="h-6 w-6" />
      </button>

      {/* 提交弹层 */}
      {open && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-4 backdrop-blur-sm"
          onClick={() => setOpen(false)}
        >
          <div
            className="w-full max-w-md rounded-2xl border border-[rgba(106,80,52,0.18)] bg-[#fcf8f2] p-6 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mb-4 flex items-start justify-between">
              <div>
                <h2 className="flex items-center gap-2 text-xl font-semibold text-[#2b241d]">
                  <Inbox className="h-5 w-5 text-[#8b2e1f]" />
                  意见信箱
                </h2>
                <p className="mt-1 text-sm text-[#756a5d]">你的整改意见会直接送到站主手上，感谢帮助我们把香研社做得更好。</p>
              </div>
              <button
                type="button"
                onClick={() => setOpen(false)}
                aria-label="关闭"
                className="rounded-full p-1.5 text-[#756a5d] hover:bg-[rgba(139,46,31,0.08)] hover:text-[#8b2e1f]"
              >
                <X className="h-5 w-5" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="mb-1.5 block text-sm font-medium text-[#5d544a]">
                  你的意见或建议 <span className="text-[#8b2e1f]">*</span>
                </label>
                <textarea
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  rows={4}
                  maxLength={2000}
                  placeholder="请写下你的意见或建议…"
                  className="w-full resize-none rounded-xl border border-[rgba(106,80,52,0.22)] bg-white px-3 py-2.5 text-sm text-[#2b241d] placeholder:text-[#b3a89b] focus:border-[#8b2e1f] focus:outline-none focus:ring-2 focus:ring-[rgba(139,46,31,0.15)]"
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#8b2e1f] px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#a03a29] disabled:cursor-not-allowed disabled:opacity-60"
              >
                <Send className="h-4 w-4" />
                {isSubmitting ? '提交中…' : '提交意见'}
              </button>
            </form>

            <div className="mt-4 border-t border-[rgba(106,80,52,0.12)] pt-3 text-center">
              <Link to="/mailbox" className="text-xs text-[#a39889] transition-colors hover:text-[#8b2e1f]">
                站主入口
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
